import PropTypes from 'prop-types';
import React, {useState} from 'react';

import {LOAD_BAR} from '../../../constants/loadBar';
import {TYPE_CLICK} from '../../../constants/tagManager';
import {P_LIST_TYPES} from '../../../constants/typesMessages';
import {
  pushInteractionTagManagerChatbot,
  pushNoInteractionTagManagerChatbot
} from '../../../services/tagManager';
import {HideButtonWhenLogout} from '../../../shared/components/HideButtonWhenLogout';
import {useChatStore} from '../../../store/slices/chatStore';
import {useEcStore} from '../../../store/slices/ecStore';
import {useInteractionStore} from '../../../store/slices/interactionStore';

const MessagePartnersQuestions = (props) => {
  const setMessages = useChatStore((state) => state.setMessages);
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const responseFlowChange = useChatStore((state) => state.responseFlowChange);
  const setChatStageFlow = useChatStore((state) => state.setChatStageFlow);
  const selectPartner = useEcStore((state) => state.selectPartner);
  const setPartnersTypeList = useInteractionStore(
    (state) => state.setPartnersTypeList
  );
  const [showButton, setShowButton] = useState('');

  const hasPartners = () => {
    setShowButton('hidden');
    pushInteractionTagManagerChatbot({
      ...TYPE_CLICK,
      elementContent: 'step-13:none:socios-sim'
    });
    let messages = [
      {
        text: 'Sim',
        type: 'response-sent'
      },
      {
        text: 'Quantos sócios(as) você tem?',
        type: 'message-receive'
      }
    ];
    setMessages(messages);
    responseTypeChange('define-number-partners');
    setPartnersTypeList(P_LIST_TYPES.P_OWN_HAS_PART);
    pushNoInteractionTagManagerChatbot({
      elementContent: 'step-14:none:quantos-socios'
    });
  };

  const hasNotPartners = () => {
    setShowButton('hidden');
    pushInteractionTagManagerChatbot({
      ...TYPE_CLICK,
      elementContent: 'step-13:none:socios-nao'
    });
    setMessages([
      {
        text: 'Não',
        type: 'response-sent'
      },
      {
        text: 'Perfeito! Continuemos com seu credenciamento...',
        type: 'message-receive'
      },
      {
        text: `Agora, me informe o CEP do endereço que está atrelado ao seu CNPJ, por favor!`,
        responseType: 'address-zipcode-without-info-bureau-input',
        type: 'message-receive-address-icon',
        index: 0,
        step: 'address'
      }
    ]);
    selectPartner({});
    responseFlowChange('');
    setChatStageFlow(LOAD_BAR.PARTNERS);
    responseTypeChange('address-zipcode-without-info-bureau-input');
    pushNoInteractionTagManagerChatbot({
      elementContent: 'step-15:none:cep'
    });
  };

  return (
    <div>
      <div className="message-line">
        <div
          className="message-receive"
          id={`msg-${props.question.id}`}
          data-aut-test="message-receive-text"
          data-testid="message-receive-text"
        >
          <div
            className="message-div"
            data-aut-test="message-partners-text-questions"
            data-testid="message-partners-text-questions"
          >
            {props.question.text}
          </div>
        </div>
      </div>
      <HideButtonWhenLogout>
        <div
          className={`message-line ${showButton}`}
          id={`button-option-test-has-partners-${props.question.id}`}
          data-aut-test="button-option-test-has-partners"
          data-testid="button-option-test-has-partners"
        >
          <div className="div-button">
            <button
              id="hasent-partners"
              data-aut-test="hasent-partners"
              data-testid="hasent-partners"
              type="button"
              onClick={() => hasNotPartners()}
            >
              NÃO
            </button>
            <button
              id="has-partners"
              data-aut-test="has-partners"
              data-testid="has-partners"
              type="button"
              onClick={() => hasPartners()}
            >
              SIM
            </button>
          </div>
        </div>
      </HideButtonWhenLogout>
    </div>
  );
};

MessagePartnersQuestions.propTypes = {
  question: PropTypes.object
};

export default MessagePartnersQuestions;
